import { LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon } from 'geojson';
import { Device } from './device';
import { Resource } from './resource';

export interface Address {
    addressLocality: string;
    postalCode: string;
    streetAddress: string;
}
export enum Permission {
    REQUEST = 'REQUEST',
    PENDING = 'PENDING',
    GRANTED = 'GRANTED',
    DENIED = 'DENIED',
    NONE = 'NONE'
}
export interface Building extends Resource {
    address: Address;
    category: string[];
    description: string;
    location: Point | MultiPoint | LineString | MultiLineString | Polygon | MultiPolygon;
    source: string;
    floorPlan?: string;
    permission?: Permission;
    irisLink?: string;
    // For Akita queries
    devices: Device[];
}
